<template>
  <v-card>
    <v-card-title> </v-card-title>
    <v-data-table
      :headers="headers"
      :items="objectives"
      :items-per-page="25"
      class="elevation-1"
      v-if="objectives"
    >
      <!-- <template v-slot:item.code="{ item }">
        <v-btn text :to="{ name: 'student', params: { id: item.id } }">
          {{ item.code }}
        </v-btn>
      </template> -->
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "dataTableStudentEducationalObjective",

  data: () => ({
    drawer: null,
    headers: [
      { text: "Code", value: "code" },
      { text: "Label", value: "edges.educational_programme.name" },
      { text: "Status", value: "status" },
      { text: "Début", value: "start" },
      { text: "Fin", value: "end" },
    ],
    objectives: null,
  }),
  mounted() {
    this.axios
      .get("/student/" + this.$route.params.id + "/educational_objective")
      .then((response) => (this.objectives = response["data"]));
  },
};
</script>